export const wrapper = [
    // Mobile
    "mobile:h-auto",
    // Tablet
    "tablet:h-24",
    // All
    "h-24",
    "bg-secondary",
];
